import React from 'react';
import DependencySelect from 'react-select';

export default function CreatableSelect(props) {
  const customStyles = {
    indicatorSeparator: (provided) => ({
      ...provided,
      width: '0px'
    }),
    input: (provided) => ({
      ...provided,
      '& div': {
        '& input': {
          boxShadow: 'none !important'
        }
      }
    }),
    ...props.selectStyles
  };
  return <DependencySelect styles={customStyles} {...props} />;
}
